export default __webpack_public_path__ + "images/15c669a148b8e27fc692f1fcd1623308-my_child_is_acting_out.svg";